import isElementInViewport from './viewport';

const initHandwritten = () => {
  // Variables
  const handwrittens: NodeListOf<HTMLElement> = document.querySelectorAll('.handwritten');

  // Functions
  const activeHandwritten = () => {
    [...handwrittens].forEach((sentence) => {
      if (isElementInViewport(sentence)) {
        const characters: NodeListOf<HTMLElement> = sentence.querySelectorAll('.handwritten__char');
        let charInterval = 0;
        [...characters].forEach((char) => {
          setTimeout(() => {
            char.classList.add('handwritten__char--active');
          }, charInterval);
          charInterval += 30;
        });
      }
    });
  };

  // Loop through all the line animations
  activeHandwritten();

  // On scroll check viewport
  window.addEventListener('scroll', () => {
    activeHandwritten();
  });
};

export default initHandwritten;
